import { DOVEIT_EXTRA_PACKAGES_DEFAULT } from '../../domain/types';
import { Agent, ExtraPackageConfig } from '../../providers/api/dtos';
import { getAgentConfiguration } from '../agent/getAgentConfiguration';

export function getAllowedDoveItPackages(agent: Agent | undefined): ExtraPackageConfig[] {
  const agentConfiguration = getAgentConfiguration(agent);

  return agentConfiguration?.extraPackages?.allowedExtraPackages || DOVEIT_EXTRA_PACKAGES_DEFAULT;
}
